import React from 'react';
import type { IHamburgerOverlayProps } from '../../../HamburgerOverlay.props';
import HamburgerOverlayCommon from '../../HamburgerOverlay';
import styles from '../../HamburgerOverlay.module.scss';
import clsx from 'clsx';
import animationClasses from '../../HamburgerOverlayAnimation.scss';
import '../../HamburgerPreHydration.scss';
import { useHamburgerMenuContext } from '../../../../HamburgerMenuContext';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import semanticClassNames from '../../../HamburgerOverlay.semanticClassNames';

const HamburgerOverlaySkin: React.FC<IHamburgerOverlayProps> = props => {
  const {
    containerRootClassName,
    showBackgroundOverlay,
    hasResponsiveLayout,
    customClassNames = [],
  } = props;

  const { isMenuOpen = false } = useHamburgerMenuContext();

  const rootClassName = clsx(
    containerRootClassName, // optional, see below
    showBackgroundOverlay && styles.showBackgroundOverlay,
    isMenuOpen && styles.isMenuOpen,
    !hasResponsiveLayout && styles.shouldScroll,
    styles.root,
    animationClasses.root,
  );

  const overlayClassName = clsx(
    styles.overlay,
    showBackgroundOverlay &&
      hasResponsiveLayout &&
      formatClassNames(semanticClassNames.root, ...customClassNames),
  );

  return (
    <HamburgerOverlayCommon
      {...props}
      rootClassName={rootClassName}
      overlayClassName={overlayClassName}
      scrollContentClassName={styles.scrollContent}
    />
  );
};

export default HamburgerOverlaySkin;
